import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	newStarredFiltersHeader: {
		id: 'spa-apps-sidebar-common.common.starred-filters-list.new-starred-filters-header',
		defaultMessage: 'Starred filters',
		description: 'Header of the starred/favourite global filters navigation section',
	},
	viewAllStarredFilters: {
		id: 'spa-apps-sidebar-common.common.starred-filters-list.view-all-starred-filters',
		defaultMessage: 'View all starred filters',
		description: 'Message for view all starred filters link in the starred filters section',
	},
});
